// src/services/api.js
const BASE_URL = process.env.REACT_APP_API_URL || '/api';

const getToken = () => localStorage.getItem('sho_token');

const headers = () => ({
  'Content-Type': 'application/json',
  ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
});

const request = async (method, path, body) => {
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: headers(),
    cache: 'no-store',
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
};

export const api = {
  // Auth
  login: (body) => request('POST', '/auth/login', body),
  register: (body) => request('POST', '/auth/register', body),
  me: () => request('GET', '/auth/me'),

  // Malls
  getMalls: () => request('GET', '/malls'),

  // Stores
  getStores: () => request('GET', '/stores'),
  getStore: (id) => request('GET', `/stores/${id}`),
  createStore: (body) => request('POST', '/stores', body),
  updateStore: (id, body) => request('PUT', `/stores/${id}`, body),
  deleteStore: (id) => request('DELETE', `/stores/${id}`),

  // Products
  getProducts: (storeId) => request('GET', `/products?storeId=${storeId}`),
  createProduct: (body) => request('POST', '/products', body),
  updateProduct: (id, body) => request('PUT', `/products/${id}`, body),
  deleteProduct: (id) => request('DELETE', `/products/${id}`),

  // Coupons
  getCoupons: (storeId) => request('GET', `/coupons?storeId=${storeId}`),
  createCoupon: (body) => request('POST', '/coupons', body),
  updateCoupon: (id, body) => request('PUT', `/coupons/${id}`, body),
  deactivateCoupon: (id) => request('DELETE', `/coupons/${id}`),

  // Analytics
  getAnalytics: (storeId) => request('GET', `/analytics/summary?storeId=${storeId}`),

  // Market price check
  checkPrices: (productName) => request('GET', `/price-check?productName=${encodeURIComponent(productName)}`),
};
